/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Page } from '../models/Page';
import type { ProspectAuditDto } from '../models/ProspectAuditDto';
import type { ProspectAuditPoints } from '../models/ProspectAuditPoints';
import type { ProspectDto } from '../models/ProspectDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProspectsService {
    /**
     * Find Prospect
     * Retrieves single prospect by id.
     * @returns ProspectDto Prospect dto.
     * @throws ApiError
     */
    public static findOneProspect({
        id,
    }: {
        /**
         * ID of prospect
         */
        id: number,
    }): CancelablePromise<ProspectDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/prospects/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Prospect not found.`,
            },
        });
    }
    /**
     * Update Prospect
     * @returns ProspectDto Updated Prospect.
     * @throws ApiError
     */
    public static updateProspect({
        id,
        requestBody,
    }: {
        /**
         * ID of prospect to be updated
         */
        id: number,
        /**
         * Details of the prospect to be updated.
         */
        requestBody: ProspectDto,
    }): CancelablePromise<ProspectDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/prospects/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input or missing required fields.`,
                403: `Unauthorized access.`,
            },
        });
    }
    /**
     * Delete Prospect
     * Deletes a specific prospect.
     * @returns void
     * @throws ApiError
     */
    public static deleteProspect({
        id,
    }: {
        /**
         * The ID of the prospect to delete
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/prospects/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Prospect not found.`,
            },
        });
    }
    /**
     * Find Prospects
     * Retrieves page with prospects.
     * @returns Page Page with prospects.
     * @throws ApiError
     */
    public static findAllProspects({
        page,
        size,
        sortBy,
        direction,
        search,
    }: {
        /**
         * Number of page
         */
        page?: number,
        /**
         * Page size
         */
        size?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort direction
         */
        direction?: string,
        /**
         * String for search by website and name
         */
        search?: string,
    }): CancelablePromise<Page> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/prospects',
            query: {
                'page': page,
                'size': size,
                'sortBy': sortBy,
                'direction': direction,
                'search': search,
            },
            errors: {
                403: `Unauthorized access.`,
            },
        });
    }
    /**
     * Create Prospect
     * @returns ProspectDto Created Prospect.
     * @throws ApiError
     */
    public static createProspect({
        requestBody,
    }: {
        /**
         * Details of the prospect to be created.
         */
        requestBody: ProspectDto,
    }): CancelablePromise<ProspectDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/prospects',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input or missing required fields.`,
                403: `Unauthorized access.`,
            },
        });
    }
    /**
     * Analyse prospect
     * Start prospect analysis or get already exists data if already analysed today.
     * @returns ProspectAuditDto Prospect dto.
     * @throws ApiError
     */
    public static auditProspect({
        prospectId,
        creatorId,
    }: {
        /**
         * ID of prospect
         */
        prospectId: number,
        /**
         * Id of the creator
         */
        creatorId: number,
    }): CancelablePromise<ProspectAuditDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/prospects/audit/{prospectId}',
            path: {
                'prospectId': prospectId,
            },
            query: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Unauthorized access.`,
                404: `Prospect not found.`,
            },
        });
    }
    /**
     * Method retrieves points configuration to build report with analyzed prospect data then
     * Method retrieves points configuration to build report with analyzed prospect data then
     * @returns ProspectAuditPoints Prospect dto.
     * @throws ApiError
     */
    public static getPointsConfig(): CancelablePromise<ProspectAuditPoints> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/prospects/audit/points-config',
            errors: {
                403: `Unauthorized access.`,
            },
        });
    }
}
